import { LIVESTOCK_SPECIES } from '@cibo/core'
import { DatePickerField, NumberInputField, SelectField } from '@cibo/ui'
import ClearIcon from '@mui/icons-material/Clear'
import { IconButton, styled } from '@mui/material'
import TableCell from '@mui/material/TableCell'
import TableRow from '@mui/material/TableRow'
import { useTranslation } from 'react-i18next'
import { EventComponentProps } from '../EventDetail'

const CompactCell = styled(TableCell)(() => ({
  paddingLeft: 4,
  paddingRight: 4,
  verticalAlign: 'top',
  '& .MuiFormControl-root': {
    width: '100%',
  },
}))

export const GrazingEventEditor = ({
  year,
  name,
  onPressRemove,
  isImmutable,
}: EventComponentProps) => {
  const { t } = useTranslation('@cibo/landmanager/GrazingEditor')
  const defaultMonth = new Date(year, 3)

  return (
    <>
      <TableRow key={name}>
        <CompactCell>
          <DatePickerField
            name={`${name}.startDate`}
            disabled={isImmutable}
            minDate={new Date(year - 1, 6, 1)}
            maxDate={new Date(year + 1, 0, 1)}
            referenceDate={defaultMonth}
            data-testid={`${name}.startDate`}
            sx={{ maxWidth: '150px', minWidth: '150px' }}
          />
        </CompactCell>

        <CompactCell>
          <SelectField
            disabled={isImmutable}
            fieldName={`${name}.species`}
            options={LIVESTOCK_SPECIES}
            renderOption={value => t('species', { context: value })}
            fullWidth
            sx={{ maxWidth: '150px', minWidth: '150px' }}
          />
        </CompactCell>

        <CompactCell>
          <NumberInputField
            name={`${name}.headCount`}
            min={1}
            step={1}
            disabled={isImmutable}
            data-testid={`${name}.headCount`}
          />
        </CompactCell>

        <CompactCell>
          <NumberInputField
            name={`${name}.daysGrazing`}
            min={1}
            max={365}
            step={1}
            disabled={isImmutable}
            data-testid={`${name}.daysGrazing`}
          />
        </CompactCell>

        <CompactCell>
          <IconButton
            aria-label={t('removeEvent') as string}
            onClick={onPressRemove}
            disabled={isImmutable}
          >
            <ClearIcon />
          </IconButton>
        </CompactCell>
      </TableRow>
    </>
  )
}
